import post from './methodPost';

export default {
  ...post
};
